<slot props={p} />
<script>
$: p = $$props
</script>